<template>
  <div class="auto-numbering">
    <div class="switch">
      <b-field grouped>
        <b-switch v-model="enable">
          Auto-number
        </b-switch>
        <div class="control" v-show="enable">
          <a href="#" @click.prevent="modalActive = true">
            <b-icon size="is-small" icon="cog" pack="fas"/>
          </a>
        </div>
      </b-field>
    </div>

    <b-modal
        v-model="modalActive"
        scroll="keep"
        has-modal-card
        trap-focus
        aria-role="dialog"
        aria-modal
        :destroy-on-hide="true">
      <form action="">
        <div class="card">
          <header class="modal-card-head">
            <p class="modal-card-title">Auto-numbering</p>
            <button class="delete" @click="modalActive = false"></button>
          </header>
          <section class="modal-card-body">
            <b-field label="Format">
              <b-radio-button v-model="format" name="format" native-value="[n]/">1/</b-radio-button>
              <b-radio-button v-model="format" name="format" native-value="/[n]">/1</b-radio-button>
              <b-radio-button v-model="format" name="format" native-value="[n]/x">1/x</b-radio-button>
              <b-radio-button v-model="format" name="format" native-value="[n]/[total]">1/10</b-radio-button>
              <b-radio-button v-model="format" name="format" native-value="([n]/[total])">(1/10)</b-radio-button>
            </b-field>
            <b-field label="Number position">
              <b-radio v-model="prefix" name="prefix" :native-value="true">Prefix</b-radio>
              <b-radio v-model="prefix" name="prefix" :native-value="false">Suffix</b-radio>
            </b-field>
            <b-field label="Skip">
              <b-checkbox v-model="skipFirst">
                Skip first tweet
              </b-checkbox>
              <b-checkbox v-model="skipLast">
                Skip last tweet
              </b-checkbox>
            </b-field>

          </section>
          <footer class="modal-card-foot">
            <b-button label="Close" @click="modalActive = false" />
          </footer>
        </div>

      </form>
    </b-modal>
  </div>

</template>
<script>
export default {
  name: 'AutoNumberToolbar',

  data() {
    return {
      modalActive: false
    }
  },
  computed: {
    enable: {
      get() { return this.get('enable') },
      set(val) { this.set('enable', val) }
    },
    prefix: {
      get() { return this.get('prefix') },
      set(val) { this.set('prefix', val) }
    },
    format: {
      get() { return this.get('format') },
      set(val) { this.set('format', val) }
    },
    skipFirst: {
      get() { return this.get('skipFirst') },
      set(val) { this.set('skipFirst', val) }
    },
    skipLast: {
      get() { return this.get('skipLast') },
      set(val) { this.set('skipLast', val) }
    },
  },
  methods: {
    get(property) {
      return this.$store.getters.composeSettings('numbering', property)
    },
    set(property, val) {
      this.$store.dispatch('setComposeSetting', {
        section: 'numbering',
        property: property,
        value: val
      })
    }
  }

}
</script>
